<header class="app-header">
  <div class="header-left">
    <p-button [rounded]="true" variant="text" (onClick)="toggleSidebar()" class="menu-button" severity="secondary" ariaLabel="Abrir menú lateral" pTooltip="Menú lateral" tooltipPosition="bottom">
      <app-sidebar-icon></app-sidebar-icon>
    </p-button>
    <div class="page-context" aria-live="polite">
      <h2>{{ pageTitle }}</h2>
      <span>{{ headerContextSubtitle }}</span>
    </div>
  </div>

  <div class="header-right">
    <p-button
      icon="pi pi-filter"
      label="Filtros Generales"
      severity="secondary"
      [outlined]="true"
      styleClass="context-change-button"
      (onClick)="openContextFilters($event)"
      [pTooltip]="organizationContextLabel"
      tooltipPosition="bottom"
      ariaLabel="Filtros generales"
    ></p-button>

    <app-filter-panel
      #contextFilterPanel
      title="Filtros Generales"
      [applyDisabled]="!hasContextChanges"
      (visibleChange)="onContextPanelVisibleChange($event)"
      (clear)="clearContextFilters()"
      (apply)="applyContextChanges()"
    >
      <ng-template>
        <section class="context-field">
          <span class="context-field-label" id="context-organizations-label"><i class="pi pi-building"></i>Organizaciones</span>
          <p-multiselect
            inputId="context-organizations"
            [options]="organizationOptions"
            optionLabel="name"
            optionValue="id"
            [ngModel]="draftOrganizationIds"
            (ngModelChange)="onDraftOrganizationsChange($event)"
            [loading]="organizationsLoading"
            [filter]="true"
            filterPlaceholder="Buscar organización..."
            placeholder="Todas las organizaciones"
            [showClear]="true"
            display="chip"
            [maxSelectedLabels]="2"
            selectedItemsLabel="{0} organizaciones"
            styleClass="w-full"
            appendTo="body"
            [disabled]="!hasPlatformAdminAccess && organizationOptions.length <= 1"
            ariaLabel="Seleccionar organizaciones"
          >
            <ng-template pTemplate="item" let-organization>
              <div class="organization-option">
                <i class="pi pi-building"></i><span>{{ organization.name }}</span>
              </div>
            </ng-template>
          </p-multiselect>
        </section>
      </ng-template>
    </app-filter-panel>

    <div *ngIf="showUsdObservedRateIndicator" class="usd-observed-indicator flex items-center gap-1.5">
      <ng-container *ngIf="usdObservedRateLoading; else usdObservedRateValue">
        <p-skeleton width="4.75rem" height="1.5rem" borderRadius="999px"></p-skeleton>
      </ng-container>

      <ng-template #usdObservedRateValue>
        <p-tag
          [value]="usdObservedRateDisplay"
          icon="pi pi-dollar"
          severity="contrast"
          [rounded]="true"
          [pTooltip]="usdObservedRateTooltip"
          tooltipStyleClass="usd-indicator-tooltip"
          tooltipPosition="bottom"
          styleClass="!text-[0.9rem] !font-semibold !px-2 !py-0.5"
        ></p-tag>
      </ng-template>
    </div>
    <app-user-actions></app-user-actions>
  </div>
</header>
